module.exports = __webpack_public_path__ + "img/role-head-back-1.0935940f.png";